export interface ValidationErrorFormatted {
  field: string;
  error: string;
  fieldType: string;
  translationFieldKey?: string;
  translationInfoKey?: string;
  translationErrorKey?: string;
}
